// This function takes a canonical url as the input
// eg: https://sharepoint.com/site/file.docx
export function getFileExtensionFromUrl(url) {
    if (!url) {
        return '';
    }
    var lastIndexOfPeriod = url.lastIndexOf('.');
    if (lastIndexOfPeriod === -1) {
        return '';
    }
    return url.substring(lastIndexOfPeriod + 1).split('?')[0];
}
//# sourceMappingURL=getFileExtensionFromUrl.js.map